<template>
  <div>
    <v-app-bar flat app hide-on-scroll height="100" class="px-xs-2 px-2">
      <app-bar-nav-icon />
      <v-toolbar-title class="page-title primary--text">
        Dashboard
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <div class="px-xs-1 px-12">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit
      ipsa iure nesciunt eveniet nemo ut perferendis, vero dolores, architecto,
      recusandae possimus enim optio sint voluptas quae harum consequuntur quas
      animi? Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi
      illum eos, harum quidem alias reiciendis. Nam aspernatur voluptatum ipsa
      iste, debitis earum, iure quos esse laboriosam repellat velit voluptatem
      eaque.
    </div>
  </div>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'DashboardPage',
  mixins: [ControlsMixin],
  components: {
    AppBarNavIcon
  }
}
</script>
